import { configureStore, ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { UndoEntry, VisualizerSlice } from './reducers/visualizer';
import { IBuildSession } from '@zerolight-core/generic-buildsession';
//import { SessionV2 } from '@zerolight-core/generic-buildsession/build/lib/buildSession';

type State = {
  configuration: ReturnType<typeof VisualizerSlice["getInitialState"]>
}



export interface ThunkAPIType
{
  currentBuildSession?: IBuildSession;
  undoStack: UndoEntry[]
}

export const store = (state?: State) => configureStore({
  preloadedState: state,
  reducer: {
    configuration: VisualizerSlice.reducer
  },
  middleware: (defaultMiddleware) =>
  {
    return defaultMiddleware({
      thunk: {
        extraArgument: <ThunkAPIType>{
          undoStack: [],
        },
      }
    })
  }
})

export type AppStore = ReturnType<typeof store>;
export type RootState = ReturnType<AppStore["getState"]>
export type AppDispatch = AppStore["dispatch"]

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  ThunkAPIType,
  UnknownAction
>